export const configurationColumnTableStableLoadsGRANLATTE = {
  column1: true /*required field*/,
  product: true /*required field*/,
  column4: true /*required field*/,
  type: true,
  column11: false,
  column3: false,
  column2: true,
  temperature: false,
  numGrease: true,
  proteins: true,
  somaticCells: true,
  bacterialCharge: true,
  casein: false,
  lactose: false,
  cryoscopicIndex: false,
  skimmedDryResidue: false,
  urea: false,
  aflatoxinsELISA: false,
  aflatoxinsHPLC: false,
  inhibitorySubstances: false,
  lacticAcid: false,
};
